import { api } from "../lib/axios";

import type { VectorEmbeddingModel } from "../types/vector";
import type { ApiData } from "./apiData";

interface UpdateVectorMetadatasNameBody {
    filesIds: Array<string>
    metadatas: Array<{ oldName: string, newName: string }>
    embeddingModelName: VectorEmbeddingModel
}

interface UpdateVectorMetadatasNameData {
    message: string
}

async function updateVectorMetadatasName(body: UpdateVectorMetadatasNameBody) {
    const response = await api.put<ApiData<UpdateVectorMetadatasNameData>>(
        '/vector/metadata/change-name',
        body
    )

    return response.data
}

export {
    updateVectorMetadatasName,
    type UpdateVectorMetadatasNameBody,
    type UpdateVectorMetadatasNameData
}